import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/usuarios/listar/form_senha'
import Head from '../../../../components/head'
import Footer from '../../../../components/footer'


function SenhaScreen () {
    return (
        <Fragment>
            <Head titulo="Alterando Senha" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SenhaScreen;